import { Container, Form, InputGroup, Image } from 'react-bootstrap';
import { Link, useNavigate } from "react-router-dom";
import TopRatedGrid from "./gridViews";
import {
    BannerSection,
    BannerWrapper,
    BannerText,
    BannerSmallText,
    MediaInquiries,
    MediaInquiriesTitle,
    FilterSection,
    SearchCol,
    TopList,
    TopHeading,
    Title,
    ViewBtn,
    ViewIcon,
    HeadingSection,
    ViewTitle,
    ViewUl,
    ViewLi,
    TopRatedListTable,
    AwardBrowse,
} from "./topRatedStyle";

import SearchIcon from '../../assests/images/search-normal.svg';
import { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FilterDropdown from '../../components/common/filterDropdown/filterDropdown';
import PaginationBlock from '../../components/common/pagination';
import LaurelSeal from '../../assests/images/laurel_seal.webp';
import { MESSAGE } from '../../utils/message';
import { TopRatedBanner, ImageTitle } from '../../components/common/topRatedGuideBanner/topRatedBannerStyle';
import CommonTable from '../../components/common/commonTable';
import RatingStar from '../../components/common/ratingStar/ratingStar';
import { TableColumnsProps, TopRatedNonprofitParamsProps } from '../../utils/types';
import { topRatedFiltersHandler, topRatedNonprofitsHandler } from '../../redux/slices/donationCamp/topRatedNonprofit-slice';
import SimpleLoader from '../../components/common/simpleLoader/Loader';

const TopRated = () => {
    const [searchTopRated, setSearchTopRated] = useState<string>("");
    const [debouncedSearch, setDebouncedSearch] = useState<string>(searchTopRated); // Debounced value
    const [selectedIssue, setSelectedIssue] = useState<string | undefined>("");
    const [selectedEveryWhere, setSelectedEveryWhere] = useState<string | undefined>("");
    const [selectedCampaigns, setSelectedCampaigns] = useState<string | null>("");
    const [viewType, setViewType] = useState<string>(MESSAGE.list);
    const [loader, setLoader] = useState(true);
    const filtersData = useSelector((state: any) => state?.topRatedNonprofits?.filters?.results)
    const nonprofitsData = useSelector((state: any) => state?.topRatedNonprofits?.data);
    const dispatch: any = useDispatch();
    const size = 10;

    const navigate: any = useNavigate();
    const [page, setPage] = useState(1);
    const [detailByRow, setDetailByRow] = useState<any>();


    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchTopRated);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTopRated]);

    const handlePageClick = (page: number) => {
        const pageNumber = page;
        setPage(pageNumber);
    };
    const handlePre = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };
    const handleNext = () => {
        if (page < nonprofitsData?.total_pages) {
            setPage(page + 1);
        }
    };

    useEffect(() => {
        if (detailByRow?.slug) {
            navigate(`/org/${detailByRow.slug}`)
        }


    }, [detailByRow])
    const causesOptions = useMemo(() => {
        const tempOptions = filtersData?.issue_list?.map((item: any) => {
            return {
                label: item?.title,
                value: item?.slug
            }
        })
        const staticOption = { label: MESSAGE.allIssues, value: "" };
        tempOptions?.unshift(staticOption);
        return tempOptions
    }, [filtersData])
    const campaignOptions = useMemo(() => {
        const tempOptions = filtersData?.campaign_list?.map((item: any) => {
            return {
                label: item?.title,
                value: item?.id
            }
        })
        // const staticOption = { label: MESSAGE.allCampaign, value: "" };
        // tempOptions?.unshift(staticOption);
        return tempOptions
    }, [filtersData])
    const stateOptions = useMemo(() => {
        const tempOptions = filtersData?.location_list?.map((item: any) => {
            return {
                label: item?.title,
                value: item?.key
            }
        })
        const staticOption = { label: MESSAGE.everywhere, value: "" };
        tempOptions?.unshift(staticOption);
        return tempOptions
    }, [filtersData])

    const columns: TableColumnsProps[] = [
        {
            id: 'title',
            header: 'Nonprofit Name'
        },
        {
            id: 'address',
            header: 'City and State'
        },
        {
            id: 'causes',
            header: 'Cause',
            render: (causes: string[]) => {
                return <p>{causes?.map((item: string) => item).join(', ')}</p>
            }
        },
        {
            id: 'rating',
            header: 'Rating',
            render: (rating: number) => {
                return <RatingStar review={0} rating={rating} />;
            }
        },
        {
            id: 'num_reviews',
            header: '# of Stories'
            
        }
    ]
    useEffect(() => {
        dispatch(topRatedFiltersHandler())
    }, [])

    useEffect(() => {
        const params: TopRatedNonprofitParamsProps = {
            category: selectedIssue ?? "",
            campaign: selectedCampaigns ?? "",
            location: selectedEveryWhere ?? "",

            search: debouncedSearch ?? "",
            page: page,
            size: size,
        }
        setLoader(true);
        dispatch(topRatedNonprofitsHandler(params))
            .then(() => setLoader(false))
            .catch(() => setLoader(false));
    }, [selectedIssue, selectedEveryWhere, selectedCampaigns, page, debouncedSearch])


    return (
        <>
            <BannerSection>
                <Container className="cont-w">
                    <BannerWrapper>
                        <TopRatedBanner>
                            <Image src={LaurelSeal} />
                            <ImageTitle>{MESSAGE.imageTitle} </ImageTitle>
                        </TopRatedBanner>
                        <BannerText>
                            <BannerSmallText>Looking for a nonprofit to support? GreatNonprofits' Top-Rated Nonprofits are endorsed by
                                clients, volunteers, and their community. Read a story from one of the nonprofits below
                                and consider donating your time or money to help further their impact! </BannerSmallText>
                            <BannerSmallText>If you have any questions or concerns, contact us at <Link to="mailto:support@greatnonprofits.org">support@greatnonprofits.org.</Link></BannerSmallText>
                            <MediaInquiries>
                                <BannerSmallText>
                                    <MediaInquiriesTitle>Press and Media Inquiries</MediaInquiriesTitle>
                                    To learn more about the GreatNonprofits Top-Rated Guide recipients, methodology, and past winners, contact us at <Link to="mailto:press@greatnonprofits.org">press@greatnonprofits.org.</Link>
                                </BannerSmallText>
                            </MediaInquiries>
                        </BannerText>
                    </BannerWrapper>
                </Container>
            </BannerSection>
            <HeadingSection>
                <Container className="cont-w">
                    <FilterSection>
                        <FilterDropdown options={causesOptions ?? []} selectedFilter={selectedIssue as string} setSelectedFilter={setSelectedIssue} />
                        <FilterDropdown options={stateOptions ?? []} selectedFilter={selectedEveryWhere as string} setSelectedFilter={setSelectedEveryWhere} />
                        <FilterDropdown options={campaignOptions ?? []} selectedFilter={selectedCampaigns} setSelectedFilter={setSelectedCampaigns} />
                        <SearchCol>
                            <Form>
                                <InputGroup>
                                    <InputGroup.Text><Image src={SearchIcon} alt='SearchIcon' /> </InputGroup.Text>
                                    <Form.Control
                                        type="text"
                                        placeholder="Search by Name"
                                        value={searchTopRated}
                                        onChange={(e) => setSearchTopRated(e.target.value)}
                                    />
                                </InputGroup>
                            </Form>
                        </SearchCol>
                    </FilterSection>
                    <TopList>
                        <TopHeading>

                            <Title>{MESSAGE.topRatedListTitle(nonprofitsData?.count, causesOptions?.find((item: any) => item?.value === selectedIssue)?.label, stateOptions?.find((item: any) => item?.value === selectedEveryWhere)?.label)}</Title>
                        </TopHeading>

                        <ViewBtn>
                            <ViewTitle>{MESSAGE.viewNonprofitsBy}</ViewTitle>
                            <ViewIcon>
                                <ViewUl>
                                    <ViewLi className={viewType === 'list' ? 'active' : ''} onClick={() => setViewType('list')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                                            <g id="Group_36810" data-name="Group 36810" transform="translate(-1242 -640)">
                                                <rect id="Rectangle_20464" data-name="Rectangle 20464" width="25" height="5" rx="1" transform="translate(1242 640)" fill="#01606f" />
                                                <rect id="Rectangle_20466" data-name="Rectangle 20466" width="25" height="5" rx="1" transform="translate(1242 650)" fill="#01606f" />
                                                <rect id="Rectangle_20467" data-name="Rectangle 20467" width="25" height="5" rx="1" transform="translate(1242 660)" fill="#01606f" />
                                            </g>
                                        </svg>
                                    </ViewLi>
                                    <ViewLi className={viewType === 'grid' ? 'active' : ''} onClick={() => setViewType('grid')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                                            <g id="Group_36811" data-name="Group 36811" transform="translate(-1282 -640)">
                                                <rect id="Rectangle_20464" data-name="Rectangle 20464" width="5" height="5" rx="1" transform="translate(1282 640)" fill="#01606f" />
                                                <rect id="Rectangle_20479" data-name="Rectangle 20479" width="5" height="5" rx="1" transform="translate(1292 640)" fill="#01606f" />
                                                <rect id="Rectangle_20482" data-name="Rectangle 20482" width="5" height="5" rx="1" transform="translate(1302 640)" fill="#01606f" />
                                                <rect id="Rectangle_20466" data-name="Rectangle 20466" width="5" height="5" rx="1" transform="translate(1282 650)" fill="#01606f" />
                                                <rect id="Rectangle_20478" data-name="Rectangle 20478" width="5" height="5" rx="1" transform="translate(1292 650)" fill="#01606f" />
                                                <rect id="Rectangle_20481" data-name="Rectangle 20481" width="5" height="5" rx="1" transform="translate(1302 650)" fill="#01606f" />
                                                <rect id="Rectangle_20467" data-name="Rectangle 20467" width="5" height="5" rx="1" transform="translate(1282 660)" fill="#01606f" />
                                                <rect id="Rectangle_20480" data-name="Rectangle 20480" width="5" height="5" rx="1" transform="translate(1292 660)" fill="#01606f" />
                                                <rect id="Rectangle_20483" data-name="Rectangle 20483" width="5" height="5" rx="1" transform="translate(1302 660)" fill="#01606f" />
                                            </g>
                                        </svg>
                                    </ViewLi>
                                </ViewUl>
                            </ViewIcon>
                        </ViewBtn>
                    </TopList>
                </Container>
            </HeadingSection>

            {
                loader ? (
                    <div style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                        <SimpleLoader />
                    </div >

                ) : nonprofitsData?.results?.length === 0 ? (
                    <h3 className="nononprofitsTitile" style={{ textAlign: "center" }}>No nonprofits found matching your criteria.</h3>
                ) : (
                    viewType === 'list' ?
                        <TopRatedListTable className='top-rated-list-table'>
                            <Container className='cont-w'>
                                <CommonTable columns={columns} data={nonprofitsData?.results} handleRowClick={(data: any) => setDetailByRow(data)} />
                            </Container>
                        </TopRatedListTable>
                        :
                        <TopRatedGrid category={selectedIssue} selectedFilter={selectedEveryWhere} data={nonprofitsData?.results} />
                )}
            <AwardBrowse>
                {!loader && nonprofitsData?.count > size && <PaginationBlock totalPage={nonprofitsData?.total_pages} page={page} handlePre={handlePre} handleNext={handleNext} handlePageClick={handlePageClick} />}
            </AwardBrowse>
        </>

    )
};
export default TopRated; 